import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Landing from './pages/Landing';
import Mint from './pages/Mint';
import Dashboard from './pages/Dashboard';
import Marketplace from './pages/Marketplace';
import Docs from './pages/Docs';
import Points from './pages/Points';
import ConnectModal from './components/ConnectModal';
import StatusBar from './components/StatusBar';
import { WalletProvider, useWallet } from './hooks/useWallet';
import { NET } from './config';
import { fmt } from './lib';
// App.css (theme) is served from public/App.css (copied by the npm scripts) so its absolute /fonts and /img urls resolve at runtime.

function ConnectButton() {
  const { account, chainId, bnb, ore, connect } = useWallet();
  if (!account) return <button className="connect-btn" data-testid="connect-btn" onClick={connect}>Connect wallet</button>;
  return (
    <div style={{ textAlign: 'right' }}>
      <div className="stat" data-testid="acct">{account.slice(0, 6)}…{account.slice(-4)}{chainId !== NET.chainId ? ' · WRONG CHAIN' : ''}</div>
      <div style={{ fontFamily: 'var(--ui)', color: 'var(--muted)', fontSize: '.85rem' }}>{fmt(bnb)} BNB · {fmt(ore, 0)} ORE · {NET.label}</div>
    </div>
  );
}

function App() {
  return (
    <WalletProvider>
      <Router>
        <div className="app">
          <nav className="nav">
            <div className="nav-logo">AgentFleet</div>
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/mint">Mint</Link>
              <Link to="/dashboard">Fleet</Link>
              <Link to="/market">Market</Link>
              <Link to="/points">Points</Link>
              <Link to="/docs">Docs</Link>
            </div>
            <ConnectButton />
          </nav>
          <StatusBar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/mint" element={<Mint />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/market" element={<Marketplace />} />
            <Route path="/points" element={<Points />} />
            <Route path="/docs" element={<Docs />} />
          </Routes>
          <ConnectModal />
        </div>
      </Router>
    </WalletProvider>
  );
}

export default App;
